import { Form } from 'antd5';
import styled from 'styled-components';

export const StyledItem = styled(Form.Item)`
  width: 100%;
`;
